// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"93c66c4d","489":"d953bb0e"}[chunkId] + ".chunk.js";
};